module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Roller-88b7328a71f22c3c9891aed0e42f911f.svg";